import React, { useState } from "react";
import { IAutomationChangeState } from "../../interfaces/IAutomation";
import { IAutomationCategory } from "../../interfaces/IAutomationCategory";
import { Button, Dialog, DialogActions, DialogContent, IconButton, TableCell, TableRow } from "@mui/material";
import { IOfferState } from "../../interfaces/IOfferState";
import { IProjectState } from "../../interfaces/IProjectState";
import { ITaskState } from "../../interfaces/ITaskState";
import { IBillState } from "../../interfaces/IBillState";
import { Delete, Edit } from "@mui/icons-material";
import { AutomationChangeStateEdit } from "./AutomationChangeStateEdit";
import { getAutomationGetStateValue } from "../../sites/AutomationManagement/AutomationOverview";

interface IProps {
    autoChangeState: IAutomationChangeState;
    autoChangeStateArray: IAutomationChangeState[];
    setAutoChangeStateArray: Function;
    autoCategoryArray: IAutomationCategory[];
    offerStateArray: IOfferState[];
    projectStateArray: IProjectState[];
    taskStateArray: ITaskState[];
    billStateArray: IBillState[];
}

export const AutomationChangeStateRow: React.FC<IProps> = ({
    autoChangeState,
    autoChangeStateArray,
    setAutoChangeStateArray,
    autoCategoryArray,
    offerStateArray,
    projectStateArray,
    taskStateArray,
    billStateArray,
}) => {
    const [editAutoChangeState, setEditAutoChangeState] = useState(autoChangeState);
    const [isOpenEdit, setIsOpenEdit] = useState(false);

    const handleOpen = () => {
        setEditAutoChangeState(autoChangeState);
        setIsOpenEdit(true);
    };
    const handleSave = () => {
        setAutoChangeStateArray([
            ...autoChangeStateArray.map((cState) =>
                cState.id === editAutoChangeState.id ? editAutoChangeState : cState,
            ),
        ]);
        setIsOpenEdit(false);
    };
    const handleRemoveMe = () => {
        setAutoChangeStateArray([...autoChangeStateArray.filter((cState) => cState.id !== editAutoChangeState.id)]);
    };

    return (
        <>
            {isOpenEdit && (
                <Dialog open onClose={() => setIsOpenEdit(false)} maxWidth="sm" fullWidth>
                    <DialogContent>
                        <AutomationChangeStateEdit
                            autoChangeState={editAutoChangeState}
                            setAutoChangeState={setEditAutoChangeState}
                            autoCategoryArray={autoCategoryArray}
                            billStateArray={billStateArray}
                            offerStateArray={offerStateArray}
                            projectStateArray={projectStateArray}
                            taskStateArray={taskStateArray}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button variant="outlined" onClick={() => setIsOpenEdit(false)}>
                            Abbruch
                        </Button>
                        <Button variant="contained" onClick={handleSave}>
                            Übernehmen
                        </Button>
                    </DialogActions>
                </Dialog>
            )}

            <TableRow>
                <TableCell>
                    {autoCategoryArray.find((cat) => cat.id === autoChangeState.AutomationCategory)?.automationCategory}
                </TableCell>
                <TableCell>
                    {getAutomationGetStateValue(
                        autoChangeState,
                        offerStateArray,
                        projectStateArray,
                        taskStateArray,
                        billStateArray,
                    )}
                </TableCell>
                <TableCell>
                    <IconButton size="small" onClick={handleOpen}>
                        <Edit />
                    </IconButton>
                    <IconButton size="small" onClick={handleRemoveMe}>
                        <Delete />
                    </IconButton>
                </TableCell>
            </TableRow>
        </>
    );
};
